/* eslint-disable default-case */
const { base64url } = require("./base64url")

export const createRecoveryCredential = async (clientData, username) => {
  return new Promise((resolve, reject) => {
    const serviceWorker = new Worker("/js/worker.js")

    serviceWorker.addEventListener("message", (event) => {
      switch (event.data.type) {
        case "encryptedPrivateKeyAndPublicKey": {
          const {
            encryptedPrivateKey,
            attestationData,
            recoveryKey,
            credentialId,
          } = event.data
          const recoveryKeyCredential = {
            credentialKind: "RecoveryKey",
            credentialInfo: {
              credId: credentialId,
              attestationData: base64url(attestationData),
              clientData: base64url(JSON.stringify(clientData)),
            },
            encryptedPrivateKey: encryptedPrivateKey,
          }
          const newRecoveryKey = {
            secret: recoveryKey,
            credentialId,
          }
          resolve({
            credential: recoveryKeyCredential,
            recoveryKey: newRecoveryKey,
          })
          break
        }
        case "error": {
          const { error } = event.data
          reject(error)
          break
        }
      }
    })

    serviceWorker.postMessage({
      type: "generateEncryptedPrivateKeyAndPublicKey",
      username: username,
      clientData: JSON.stringify(clientData),
    })
  })
}

export const validateRecoveryKey = async (username, existingRecoveryKey) => {
  return new Promise((resolve, reject) => {
    const serviceWorker = new Worker("/js/worker.js")

    serviceWorker.addEventListener("message", (event) => {
      switch (event.data.type) {
        case "recoveryKeyIsValid": {
          resolve()
          break
        }
        case "error": {
          const { error } = event.data
          reject(error)
          break
        }
      }
    })

    serviceWorker.postMessage({
      type: "validateRecoveryKey",
      username: username,
      recoveryKey: existingRecoveryKey.recoveryKey,
      encryptedPrivateKey: existingRecoveryKey.encryptedKey,
      credentialId: existingRecoveryKey.credentialId,
    })
  })
}

export const signRecoveryCredentials = async (
  username,
  existingRecoveryKey,
  newCredentials
) => {
  return new Promise((resolve, reject) => {
    const recoveryClientData = JSON.stringify({
      type: "key.get",
      challenge: base64url(JSON.stringify(newCredentials)),
      origin: window.location.origin,
      crossOrigin: false,
    })

    const serviceWorker = new Worker("/js/worker.js")

    serviceWorker.addEventListener("message", (event) => {
      switch (event.data.type) {
        case "signature": {
          const { signature } = event.data

          resolve({
            kind: "RecoveryKey",
            credentialAssertion: {
              credId: existingRecoveryKey.credentialId,
              clientData: base64url(recoveryClientData),
              signature: signature,
            },
          })
          break
        }
        case "error": {
          const { error } = event.data
          reject(error)
          break
        }
      }
    })

    serviceWorker.postMessage({
      type: "generateSignature",
      username: username,
      message: recoveryClientData,
      recoveryKey: existingRecoveryKey.recoveryKey,
      encryptedPrivateKey: existingRecoveryKey.encryptedKey,
      credentialId: existingRecoveryKey.credentialId,
    })
  })
}
